import PendingLocationsBanner from './PendingLocationsBanner';
export default PendingLocationsBanner;
